import React from 'react'

const Headline = ({ title }) => {
    return (
        <div className='mb-5 border-b-4 border-b-gray-800 '>
            <h1 className='text-2xl text-center mb-3'>{title}</h1>

        </div>
    )
}

export default Headline